//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  ObserveVisibility
} from "vue-observe-visibility";

export default {
  data: function () {
    return {
      isOpenModal: false,
      isShowFixedButton: false
    }
  },

  props: {
    filter: {
      type: Array,
      default: () => {
        return []
      }
    },
    category: {
      type: Object,
      default: () => {
        return {}
      }
    },
    filterPrice: {
      type: Object,
      default: () => {
        return {}
      }
    },
    selectedFilters: {
      type: Object,
      default: () => {
        return {}
      }
    },
    totalProducts: {
      type: [String, Number],
      default: "0"
    },

    loading: {
      type: Boolean,
      default: false
    },
    isShowFilterSelected: {
      type: Boolean,
      default: false
    },
  },

  computed: {
    labelButtonSubmit: function () {
      const count = this.totalProducts;
      const word = this.$caseWords(+count, ['товар','товара','товаров'])
      return `Показать ${ count } ${ word }`
    },
  },

  directives: {
    ObserveVisibility,
  },

  components: {
    FilterItems: () => import('~/components/catalog-new/FilterItems.vue'),
  },

  methods: {
    openModal: function () {
      this.isOpenModal = true;
    },
    closeModal: function () {
      this.isOpenModal = false;
    },

    fastUpdate: function (filters = {}) {
      this.$emit('fastUpdate', filters);
    },
    requestUpdateFilter: function (filters = {}) {
      this.$emit("requestUpdateFilter", filters);
    },

    callBackFixedButton: function (isVisible) {
      this.isShowFixedButton = !isVisible;
    },
  }
}
